// Fontes auto-hospedadas (@fontsource-variable): a aula às vezes acontece sem
// rede (ver DECISAO-3D.md), então a tipografia não pode depender do Google
// Fonts. As variações 'Variable' cobrem os eixos opsz/wght usados no design
// original — os nomes de família batem com `--font-display`/`--font-body`/
// `--font-mono` em styles.css.
import '@fontsource-variable/bricolage-grotesque/standard.css'
import '@fontsource-variable/figtree'
import '@fontsource-variable/figtree/wght-italic.css'
import '@fontsource-variable/jetbrains-mono'
import './apresentacao/tabletop/mesa.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

